import {CommonModule} from "@angular/common"
import {Component, inject, OnInit, signal, ChangeDetectionStrategy} from "@angular/core"
import {MaterialNode} from "@cm/material-nodes"
import {injectTippyRef, TIPPY_REF} from "@ngneat/helipopper"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-debug-material-parameters-tooltip",
    imports: [CommonModule],
    templateUrl: "./debug-material-parameters-tooltip.component.html",
    styleUrl: "./debug-material-parameters-tooltip.component.scss",
})
export class DebugMaterialParametersTooltipComponent implements OnInit {
    tippy = injectTippyRef()
    tippyRef = inject(TIPPY_REF)

    public model: MaterialNode = this.tippyRef.data

    readonly $parametersList = signal<object | undefined>(undefined)

    ngOnInit() {
        this.$parametersList.set(this.model.parameters.settings)
    }
}
